// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1rzVn","errorLogs":"styles_errorLogs__2uor6"};